export default "__VITE_ASSET__d423a5ea__"